export default __webpack_public_path__ + "static/media/Snd_CR.74bef965.mp3";